/*
 * ZOOM IMAGE FICHE PRODUIT
 * --------------------------------------------------------------------------
 * Réutilise la lightbox native du thème (PhotoSwipe) via l'événement public
 * « lightbox:open » écouté par <product-gallery> (theme.js). On n'édite donc
 * PAS theme.js.
 *
 *   Clic / tap sur l'image (desktop ET mobile) = ouvre la lightbox sur cette
 *     image. Le bouton loupe desktop est masqué (CSS). Sur mobile, un swipe
 *     ne déclenche pas de « click » (supprimé par le navigateur après défile-
 *     ment) → seul un vrai tap immobile ouvre la lightbox.
 *   Mobile Android : pincer (2 doigts) sur l'image = ouvre aussi la lightbox.
 *     iOS Safari gère déjà le pinch nativement (gesturestart) → on n'y touche
 *     pas, pour éviter un double déclenchement.
 *
 * Le bouton loupe mobile natif reste en place (repli / accessibilité).
 */
(function () {
  'use strict';

  // iOS Safari expose GestureEvent → pinch déjà géré nativement par le thème.
  var HAS_NATIVE_PINCH = typeof window.GestureEvent !== 'undefined';

  /* ----------------------------------------------------------------------
   * Clic (desktop) / tap (mobile) sur l'image → lightbox
   * -------------------------------------------------------------------- */
  function onGalleryClick(event) {
    var gallery = event.target.closest('product-gallery');
    if (!gallery) {
      return;
    }

    // En layout « carrousel », le thème utilise déjà le clic gauche/droit pour
    // naviguer (curseur perso). On ne s'active qu'en layout grille (pas de
    // .custom-cursor), où le clic image ne fait rien nativement.
    if (gallery.querySelector('.custom-cursor')) {
      return;
    }

    var cell = event.target.closest('.product-gallery__media');
    if (!cell || cell.getAttribute('data-media-type') !== 'image') {
      return;
    }

    // On laisse passer les vrais éléments interactifs (wishlist, liens, AR…).
    if (event.target.closest('button, a, .st-wishlist-button')) {
      return;
    }

    // Réutilise le bouton natif (caché) de la cellule → bon index d'image.
    var trigger = cell.querySelector('open-lightbox-button');
    if (trigger) {
      trigger.click();
    } else {
      gallery.dispatchEvent(
        new CustomEvent('lightbox:open', { bubbles: true, detail: { index: null } })
      );
    }
  }

  document.addEventListener('click', onGalleryClick);

  /* ----------------------------------------------------------------------
   * Mobile Android : pincer pour ouvrir la lightbox
   * -------------------------------------------------------------------- */
  function distance(touches) {
    var dx = touches[0].clientX - touches[1].clientX;
    var dy = touches[0].clientY - touches[1].clientY;
    return Math.sqrt(dx * dx + dy * dy);
  }

  function initPinch(gallery) {
    if (HAS_NATIVE_PINCH) {
      return; // iOS Safari : pinch natif.
    }
    if (!gallery.hasAttribute('allow-zoom')) {
      return; // Zoom désactivé dans les réglages.
    }

    var carousel = gallery.querySelector('.product-gallery__carousel');
    if (!carousel) {
      return;
    }

    var startDist = 0;
    var opened = false;

    carousel.addEventListener(
      'touchstart',
      function (e) {
        if (e.touches.length === 2) {
          startDist = distance(e.touches);
          opened = false;
        }
      },
      { passive: true }
    );

    carousel.addEventListener(
      'touchmove',
      function (e) {
        if (e.touches.length !== 2 || opened || startDist === 0) {
          return;
        }
        e.preventDefault(); // empêche le zoom de page pendant le pincement
        if (distance(e.touches) / startDist > 1.3) {
          var cell =
            carousel.selectedCell || carousel.querySelector('.product-gallery__media');
          if (cell && cell.getAttribute('data-media-type') === 'image') {
            opened = true;
            gallery.dispatchEvent(
              new CustomEvent('lightbox:open', { bubbles: true, detail: { index: null } })
            );
          }
        }
      },
      { passive: false }
    );

    carousel.addEventListener(
      'touchend',
      function (e) {
        if (e.touches.length < 2) {
          startDist = 0;
        }
      },
      { passive: true }
    );
  }

  function init() {
    document.querySelectorAll('product-gallery').forEach(initPinch);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
